/* This file is autogenerated, see readme.md for instructions */
import MoveSvgIcon from '@bloomreach/banana-theme/icons/move.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MoveIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MoveSvgIcon />
    </Icon>
  );
});

MoveIcon.displayName = 'MoveIcon';

export default MoveIcon;
